import React from "react";
import PropTypes from "prop-types";

function withInitialTargeting(WrappedComponent) {
  class WithInitialTargeting extends React.Component {
    constructor(props) {
      super(props);
      this.staticProps = {
        initialTargeting: Object.entries(props.initialTargeting).reduce(
          (output, [key, value]) =>
            output + `.setTargeting("${key}",${JSON.stringify(value)})`,
          ""
        )
      };
    }

    displayName() {
      return `withInitialTargeting(${
        WrappedComponent.displayName || WrappedComponent.name || "Component"
      })`;
    }

    render() {
      // eslint-disable-next-line no-unused-vars
      const { initialTargeting, ...passThroughProps } = this.props;

      return (
        <WrappedComponent {...{ ...this.staticProps, ...passThroughProps }} />
      );
    }
  }

  WithInitialTargeting.propTypes = {
    initialTargeting: PropTypes.object.isRequired
  };

  return WithInitialTargeting;
}

export default withInitialTargeting;
